import s from './PerformanceGraphNullState.module.css';
import performanceGraphNullStateImage from './performance_graph_null_state.png';

function PerformanceGraphNullState() {
  return (
    <div className={s.performanceGraphNullStateContainer}>
      <img
        src={performanceGraphNullStateImage}
        alt="No Student Performance Overview Data"
      />
      <span className={s.performanceGraphNullStateText}>
        There isn't any data to display at this time. <br />
        Data on student and course performance will appear after the first week
        scores are available.
      </span>
    </div>
  );
}

export default PerformanceGraphNullState;
